// menu-selection.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuSelectionService {
    private selectedMenuSource = new BehaviorSubject<string>('1'); // Default: Retail
    selectedMenu$ = this.selectedMenuSource.asObservable();

    setMenu(menu: string) {
        this.selectedMenuSource.next(menu);
    }
}
